<template>
  <div>
    <modal name="map">
      <div class="container" style="padding-right: 0px; margin-right:0px">
        <div class="row" style="margin:0px">
          <div class="col-md-7">
            <l-map
              :zoom="zoom"
              :center="center"
              style="width:100%;height:500px; margin-top:30px; margin-bottom:30px"
            >
              <l-tile-layer :url="url" :attribution="attribution" />
              <l-marker
                v-for="marker in markers"
                :key="marker.id"
                :lat-lng.sync="marker.position"
                @click="alert(marker)"
              >
                <l-tooltip :content="marker.longName" />
              </l-marker>
            </l-map>
          </div>
          <div class="col-md-5" style="background-color:#F5F4F4;">
            <div class="row">
              <div class="col-md-12" @click="hideModal" style="text-align:right;padding-top:5px">
                <span style="cursor:pointer">X</span>
              </div>
            </div>
            <div>
              <p v-if="!currentSelect">
                Te invitamos a dar clic sobre uno de puntos señalados en el mapa para conocer más información de la experiencia
              </p>
            </div>
            <div v-if="currentSelect" style="marginTop:40px">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h1
                    style="color:#606060;font-size:34px;text-transform: uppercase;"
                  >{{currentSelect.locationDepartments.department}}</h1>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <p>
                    <strong>Código:</strong>
                  </p>
                  <p>
                    <strong>{{currentSelect.code}}</strong>
                  </p>
                  <p>
                    <strong>Nombre:</strong>
                  </p>
                  <p>{{currentSelect.longName}}</p>
                  <p>
                    <a
                      href="#"
                      @click="(navigation(currentSelect.id))"
                      style="text-decoration: underline;"
                    >Ver más</a>
                  </p>
                  <hr />
                </div>
                <div class="row" style="margin-left:10px">
                  <div class="col-md-2">
                    <font-awesome-icon class="fa-2x" icon="marker" :style="{ color: 'red' }" />
                  </div>
                  <div class="col-md-10">
                    <p>{{currentSelect.locationDepartments.department}} ({{currentSelect.locationDepartments.code}})</p>
                    <p>{{currentSelect.locationMunicipalities.municipality}} ({{currentSelect.locationMunicipalities.codeMun}})</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div :id="svgId" class="svg-container"></div>
  </div>
</template>
<style>
.v--modal-box {
  width: 600px !important;
  margin: auto !important;
  left: 0px !important;
  height: 600px !important;
  top: 60px !important;
}
</style>

<script>
import colombianMap from "../assets/map";
import axios from "axios";

import { LMap, LTileLayer, LMarker, LTooltip } from "vue2-leaflet"; // VALID
import { latLng } from "leaflet";
import config from "../../helpers/config";
export default {
  name: "VenueMapComponent",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
  },
  data: function() {
    return {
      zoom: 9,
      currentSelect: false,
      center: latLng(47.41322, -1.219482),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      text: "my marker popup text",
      title: "My marker popup title",
      svgId: "colombianMap",
      mapAttr: {
        viewBoxWidth: 1106,
        viewBoxHeight: 800,
        imageWidth: 1106,
        imageHeight: 600
      },
      svgContainer: null,
      exp: null,
      depCode: [],
      currentExp: false,
      markers: []
    };
  },
  mounted: function() {
    this.getExperiences().then(item => {
      this.generateVenueMap();
    });
  },
  watch: {
    currentExp(val) {
      let geos = [];
      if (this.currentExp) {
        this.currentExp.forEach((item, index) => {
          if (item.locationMunicipalities) {
            const { lat, lng } = item.locationMunicipalities.geoValue;
            this.center = latLng(lat, lng);
            geos.push({
              position: latLng(lat, lng),
              id: index,
              expId: item.id,
              exp: item
            });
          }
        });
      }
      this.markers = geos;
    }
  },
  computed: {
    currentGeo: function() {
      let geos = [];
      if (this.currentExp) {
        this.currentExp.forEach((item, index) => {
          if (item.locationMunicipalities) {
            const { lat, lng } = item.locationMunicipalities.geoValue;
            this.center = latLng(lat, lng);
            geos.push({
              position: latLng(lat, lng),
              id: index
            });
          }
          return geos;
        });
      }
    }
  },
  methods: {
    navigation(experience) {
      this.$router.push({ name: "DetalleExp", query: { user_id: experience } });
    },
    alert(item) {
      //console.log(item);
      this.currentSelect = item.exp;
    },
    hideModal() {
      this.$modal.hide("map");
    },
    getExperiences() {
      return axios
        .get(
          `${config.urlApi}/experiences?filter[include]=locationDepartments&filter[include]=locationMunicipalities&filter[where][expStatusId]=1`
        )
        .then(({ data }) => {
          this.exp = data;
          this.depCode = data
            .filter(item => {
              return item.locationDepartments;
            })
            .map(({ locationDepartments }) => {
              return {
                code: locationDepartments.code,
                id: locationDepartments.id,
                idDep : locationDepartments.idLocation
              };
            });

          this.munLoc = data.map(el => {
            //console.log(el);
            try {
              const { geoValue } = el.locationMunicipalities;

              return { ...geoValue, id: el.id };
            } catch (error) {
              //console.log(error);
              return false;
            }
          });
          //console.log(this.munLoc);
          this.isLoading = false;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    getExpBy(id) {
      console.log(id)
      return axios
        .get(
          `${config.urlApi}/experiences?filter[where][locationId]=${id}&filter[include]=locationDepartments&filter[include]=locationMunicipalities&filter[where][expStatusId]=1`
        )
        .then(({ data }) => {
          this.currentExp = data;

          this.isLoading = false;
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    generateVenueMap: function() {
      const vue = this;
      const mapData = colombianMap.g.path;
      const svgContainer = vue
        .$svg("colombianMap")
        .size("140%", "140%")
        .viewbox(0, 0, vue.mapAttr.viewBoxWidth, vue.mapAttr.viewBoxHeight);
      vue.svgContainer = svgContainer;
      mapData.forEach(pathObj => {
        vue.generatePath(svgContainer, pathObj);
      });
    },
    generatePath: function(svgCont, pathObj) {
      const vue = this;

      const isDep = vue.depCode.find(function(element) {
        return element.code == parseInt(pathObj["-code"]);
      });
      
      const attrs = {
        fill: isDep ? "#8470ff" : "#e8f2ff",
        style: isDep ? "cursor: pointer" : "",
        stroke: "white",
        "stroke-width": 2,
        title: pathObj["-title"],
        code: pathObj["-code"],
        "map-id": pathObj["-id"]
      };
      const element = svgCont.path(pathObj["-d"]).attr(attrs);
      element.click(function() {
        const mapId = this.node.attributes["map-id"].value;
        const select = vue.depCode.find(function(element) {
          return element.code == parseInt(attrs.code);
        });
        console.log("E2",select);

        if (select) {
          vue.currentSelect = false;
          vue.getExpBy(select.idDep);
          vue.$modal.show("map");
        }
        const title = this.node.attributes["title"].value;
                const code = this.node.attributes["code"];

        vue.$emit("map-clicked", { mapId, title,code });
      });
    }
  }
};
</script>
